import {Article} from './article';
import {PricingItem} from './pricing-item';

export abstract class AbstractDeviceConsumablePricingItem extends PricingItem {
    public device?: Article;
    public consumable?: Article;
    public consumableExtraPrice?: string;
    public oldConsumableExtraPrice?: string;
    public specificities?: Record<string, any>;
    public effTheo?: number;
    public franchise?: any;
    public discount?: string;
    public totalAppliedPriceColor?: string;
}
